module.exports = __webpack_public_path__ + "img/A2.1042e891.png";